import Footer from "../../component/Footer/Footer";
import { Navbar } from "../../component/Navbar/NavBar";
import { HotelsContent } from "./Hotels.content";

export const HotelsPage = () => {
  return (
    <div className="d-flex flex-column vh-100">
      <Navbar fixedTop={false} />
      <HotelsContent />
      <Footer />
    </div>
  );
};